export default {
  id: 226,
  title: 'Target #226 - Bond',
  url: 'https://cssbattle.dev/play/226',
  colors: ['#558C90', '#FFFFFF', '#325853'],
  solution:
    '<p a><p b><style>p[a],p[b]{top:125;height:50}body{background:#558c90}p{position:fixed;margin:0}p[a]{left:0;width:400;background:#fff}p[b]{left:113;width:50;background:#325853;border-radius:1in;box-shadow:0 0 0 37px #fff,124px 0 #325853,124px 0 0 37px #fff',
}
